import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import TrialRequestModal from './TrialRequestModal';
import './ArticleCta.css';

// Variant + marketsHref are kept for backward compatibility with existing
// content metadata (Pulse + Press still pass `ctaVariant` / `ctaMarketsHref`).
// Both are intentional no-ops now: every article renders the same CTA so the
// experience is identical between Pulse and Press regardless of which variant
// the author originally tagged the article with.
export type ArticleCtaVariant = 'trial' | 'contact' | 'markets';

export interface ArticleCtaProps {
  variant?: ArticleCtaVariant;
  marketsHref?: string;
}

const scrollToPricing = () => {
  const section = document.getElementById('pricing');
  if (section) {
    section.scrollIntoView({ behavior: 'smooth' });
  } else {
    window.location.hash = 'pricing';
  }
};

const ArticleCta: React.FC<ArticleCtaProps> = () => {
  const navigate = useNavigate();
  const [isTrialModalOpen, setIsTrialModalOpen] = useState(false);

  const handlePricing = () => {
    if (window.location.pathname === '/') {
      scrollToPricing();
      return;
    }
    navigate('/');
    // Wait for the landing page to mount before scrolling.
    setTimeout(scrollToPricing, 300);
  };

  return (
    <>
      <aside className="article-cta" aria-labelledby="article-cta-heading">
        <span className="article-cta-eyebrow">Go deeper</span>
        <h2 id="article-cta-heading" className="article-cta-heading">
          Explore the live market dashboard
        </h2>
        <p className="article-cta-body">
          See the pipeline candidates, regional forecasts, and competitive dynamics behind this briefing on
          the SNS Market Intelligence Platform.
        </p>
        <div className="article-cta-actions">
          <Button
            type="primary"
            size="large"
            icon={<ArrowRightOutlined />}
            iconPosition="end"
            onClick={() => setIsTrialModalOpen(true)}
          >
            Request Free Trial
          </Button>
          <Button
            type="default"
            size="large"
            onClick={handlePricing}
            className="article-cta-secondary"
          >
            Pricing
          </Button>
        </div>
        <p className="article-cta-note">
          Or email us directly at{' '}
          <a href="mailto:info@snsintel.com">info@snsintel.com</a>.
        </p>
      </aside>

      <TrialRequestModal
        open={isTrialModalOpen}
        onClose={() => setIsTrialModalOpen(false)}
      />
    </>
  );
};

export default ArticleCta;
